import { lazy, Suspense } from "react";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { ValidationBar } from "@/components/ValidationBar";
import { AnimatedOrbs } from "@/components/AnimatedOrbs";
import { useCopyProtection } from "@/hooks/useCopyProtection";
import { SEO } from "@/components/SEO";

// Lazy-load below-the-fold sections to reduce initial JS bundle and TBT.
const HowItWorksSection = lazy(() =>
  import("@/components/HowItWorksSection").then((m) => ({ default: m.HowItWorksSection })),
);
const TechnologySection = lazy(() =>
  import("@/components/TechnologySection").then((m) => ({ default: m.TechnologySection })),
);
const SocialSection = lazy(() =>
  import("@/components/SocialSection").then((m) => ({ default: m.SocialSection })),
);
const MarketplaceSection = lazy(() =>
  import("@/components/MarketplaceSection").then((m) => ({ default: m.MarketplaceSection })),
);
const PrivacySection = lazy(() =>
  import("@/components/PrivacySection").then((m) => ({ default: m.PrivacySection })),
);
const FoundersSection = lazy(() =>
  import("@/components/FoundersSection").then((m) => ({ default: m.FoundersSection })),
);
const FAQSection = lazy(() =>
  import("@/components/FAQSection").then((m) => ({ default: m.FAQSection })),
);
const Footer = lazy(() =>
  import("@/components/Footer").then((m) => ({ default: m.Footer })),
);

const Index = () => {
  useCopyProtection();

  return (
    <div className="min-h-screen bg-background select-none">
      <SEO
        title="IDK:W2W | AI Virtual Try-On & Digital Wardrobe"
        description="IDK:W2W — your digital twin, powered by AI. Try on clothes virtually before you buy. Join the exclusive beta waitlist for the future of fashion."
        path="/"
      />
      <AnimatedOrbs />
      <Navbar />
      <HeroSection />
      <ValidationBar />
      <Suspense fallback={null}>
        <HowItWorksSection />
        <TechnologySection />
        <SocialSection />
        <MarketplaceSection />
        <PrivacySection />
        <FoundersSection />
        <FAQSection />
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
